import { useCallback } from 'react';
import { AccountType, sendUtagView, useTealiumDataLayer } from '@nextgen-web-framework/all';
import { Logger } from '@nextgen-web-framework/core';
import ProfileEventsEnum from '../types/enums/profileEnums';

const logger = Logger.getInstance();

export function useRegistrationCompletionEvent() {
  const dataLayer = useTealiumDataLayer();

  const registerCompletion = useCallback(
    (accountType: AccountType) => {
      let event = '';
      switch (accountType) {
        case AccountType.BusinessOwner:
          event = ProfileEventsEnum.AboRegistrationComplete;
          break;
        case AccountType.Member:
          event = ProfileEventsEnum.MemberRegistrationComplete;
          break;
        case AccountType.Customer:
          event = ProfileEventsEnum.CustomerRegistrationComplete;
          break;
        default:
          event = '';
      }
      logger.log(event, 'e');
      return event ? sendUtagView(event, dataLayer) : null;
    },
    [dataLayer],
  );

  return registerCompletion;
}

export function useRegistrationStartEvent() {
  const dataLayer = useTealiumDataLayer();

  const registerStartedTealiumEvent = useCallback(
    (accountType: AccountType) => {
      let event = '';
      switch (accountType) {
        case AccountType.BusinessOwner:
          event = ProfileEventsEnum.AboRegistrationStart;
          break;
        case AccountType.Member:
          event = ProfileEventsEnum.MemberRegistrationStart;
          break;
        case AccountType.Customer:
          event = ProfileEventsEnum.CustomerRegistrationStart;
          break;
        default:
          event = '';
      }
      logger.log(event, 'e');
      return event ? sendUtagView(event, dataLayer) : null;
    },
    [dataLayer],
  );

  return registerStartedTealiumEvent;
}
